/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'GOVERNMENT_WEBSITES',
              'GOVERNMENT_OFFICES_COMMUNICATIONS',
              'CONSULTANTS',
              'INTERNET',
              'CUSTOMER_BRIEFING',
              'HEALTH_AND_SAFETY_EXECUTIVE',
              'CORPORATE_SOCIAL_RESPONSIBILITY_OR_CSR_TEAM_ESTABLISHED_IN_FACI',
              'MANAGEMENT_TEAM_BRIEFS_THE_WORKFORCE',
              'APPOINTED_WORKER_TEAM',
              'MAGAZINE_SUBSCRIPTION_S_',
              'INDUSTRY_BODY_BRIEFINGS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_a_system_for_reviewing_policies_and_procedure: valueSchema,
  },
}
